<template>
  <div class="equities-edit">
    <page-header header="Edit IOI" />
    <edit-form
      ref="edit"
      v-if="data"
      :data="data"
      :edit="true"
      @action="updateIOI"
    />
  </div>
</template>

<script>
import EditForm from './Form'
import {errorNotification, successNotification} from '@/notifications'

export default {
  components: {
    EditForm,
  },

  data () {
    return {
      data: {},
    }
  },

  async activated () {
    try {
      const {data} = await this.$http.get(`/iois/iois/id/${this.$route.params.id}`)
      this.data = data[0]
      console.log(this.data)
    } catch (error) {
      console.error(error)
    }
  },

  methods: {
    async updateIOI (ioi) {
      const userId = this.$login.getUser().id
      try {
        await this.$http.post('/iois/iois/update-ioi', ioi, {headers: {userId}})
        this.$notify(successNotification('Successfully updated IOI'))
      } catch (error) {
        this.$notify(errorNotification('Error'))
        throw new Error(error)
      }
    },
  },
}
</script>

